module.exports = __webpack_public_path__ + "static/media/no-selected-answer-feedback.1940fa1c.mp3";